import * as React from "react";
import { JSX } from "react";
import { Box, IconButton, TextField, Typography } from "@mui/material"
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ClearIcon from "@mui/icons-material/Clear";
import SearchIcon from "@mui/icons-material/Search";
import { styled } from "@mui/material/styles";
const SearchBarContainer = styled(Box)(({ theme }) => ({
    width: "100%",
    padding: "8px 16px",
    justifyContent: "space-between",
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    border: "none",
}))
const SearchBarTextField = styled(TextField)(({ theme }) => ({
    [theme.breakpoints.down("xs")]: {
        width: "100%",
    },
    margin: theme.spacing(1, 0.5, 1.5),
    "& .MuiSvgIcon-root": {
        marginRight: theme.spacing(0.5),
    },
    "& .MuiInput-underline:before": {
        borderBottom: `1px solid ${theme.palette.divider}`,
    },
}))


export interface SearchToolbarProps {
    title?: string;
    subTitle?: string;
    value?: string | undefined;
    children?: React.FunctionComponent | Element | JSX.Element;
    onChange?: (event: any) => void;
    onClickBack?: () => void;
    clearSearch?: () => void;
}

export default function SearchToolbar(props: SearchToolbarProps) {
    const { title, subTitle, onClickBack } = props;
    return (
        <SearchBarContainer>       <Box component="div" sx={{ mt: 1, mb: 1, ml: 0, display: "flex" }}>
            {onClickBack && (
                <IconButton onClick={onClickBack} sx={{ marginRight: "8px" }}>
                    <ChevronLeftIcon />
                </IconButton>
            )}
            {title && (
                <Box>
                    <Typography variant="h4" sx={{ textAlign: "left" }}>
                        {title}
                    </Typography>
                </Box>
            )}
            {subTitle && (
                <Box>
                    <Typography variant="body1" sx={(t: any) => ({ color: t.palette.grey[500], textAlign: "left" })}>
                        {subTitle}
                    </Typography>
                </Box>
            )}
            <>
                {props.children}
            </>
        </Box>
            <SearchBarTextField
                autoFocus
                variant="standard"
                value={props.value}
                onChange={props.onChange}
                placeholder="Search…"
                InputProps={{
                    startAdornment: <SearchIcon fontSize="small" />,
                    endAdornment: (
                        <IconButton
                            title="Clear"
                            aria-label="Clear"
                            size="large"
                            sx={{ visibility: props.value ? "visible" : "hidden" }}
                            onClick={props.clearSearch}
                        >
                            <ClearIcon fontSize="small" />
                        </IconButton>
                    ),
                }}
            />
        </SearchBarContainer>
    );
}
